import { AppliedBundle as ApiAppliedBundle } from '@vendasta/billing';

export const isAppliedBundle = (b: AppliedBundle | undefined): b is AppliedBundle => {
  return !!b;
};
export interface AppliedBundle {
  bundleId?: string;
  bundleInstanceId?: string;
  name?: string;
  bundleItems?: AppliedBundleItem[];
  hideBundleItems?: boolean;
}

export interface AppliedBundleItem {
  productId?: string;
  discountType?: string;
  discountAmount?: number;
  quantity?: number;
}

export function convertApiAppliedBundle(ab: ApiAppliedBundle): AppliedBundle | undefined {
  if (!ab) {
    return undefined;
  }

  return {
    bundleId: ab.bundleId,
    bundleInstanceId: ab.bundleInstanceId,
    name: ab.name,
    hideBundleItems: ab.hideBundleItems || false,
  };
}
